import { render } from "./date-range.vue?vue&type=template&id=53512c76"
import script from "./date-range.vue?vue&type=script&lang=js"
export * from "./date-range.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__